<!-- <div class="mb-1">
  <input
    pInputText
    type="text"
    #inputFilter
    (input)="dt1.filterGlobal(inputFilter.value, 'contains')"
    placeholder="Cerca per seriale..."
    class="w-full"
  />
</div> -->
<form
  [formGroup]="frm_search"
  class="p-fluid grid"
  *ngIf="selection">
  <!-- ricerca per seriale -->
  <div class="col-12">
    <span class="p-input-icon-left w-full">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        placeholder="Cerca serial number..."
        aria-label="Cerca serial number"
        formControlName="search" />
    </span>
  </div>
</form>

<ng-container *ngIf="!loadedAllAssets">
  <p-table
    [value]="[]"
    [paginator]="true"
    [rows]="25"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
    [loading]="true">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th *ngIf="selection"></th>
        <th>Serial number</th>
        <th>Utilizzo</th>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
<ng-container *ngIf="loadedAllAssets">
  <p-table
    [value]="assets"
    #dt1
    dataKey="id"
    [rowSelectable]="isRowSelectable"
    [loading]="loading && !loadedAllAssets"
    [(selection)]="selectedAssets"
    [selectionMode]="'multiple'">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th *ngIf="selection">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th>Serial number</th>
        <th>Asset code</th>
        <th>Utilizzo</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-s>
      <tr>
        <td *ngIf="selection">
          <p-tableCheckbox
            [value]="s"
            [disabled]="
              s.related_delivery_id && s.related_delivery_id !== related_delivery_id
            "></p-tableCheckbox>
          <!-- <p-checkbox
          [disabled]="s.related_delivery_id && s.related_delivery_id !== related_delivery_id"
          [(ngModel)]="selectedAssets"
          [value]="s"
          [trueValue]="s" /> -->
        </td>
        <td>
          <ng-container *ngIf="selection"
            >{{ s.serial_number }} ({{ s.asset_code || '-' }})</ng-container
          >
          <p-chip
            *ngIf="!selection"
            [label]="s.serial_number + ' (' + (s.asset_code || '-') + ')'"></p-chip>
        </td>
        <td>
          {{ s.asset_code || 'N.D.' }}
        </td>
        <td>{{ s | assetUtilizzo }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="4"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="frm_search.get('skip')!.value!"
    [rows]="frm_search.get('pageSize')!.value!"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali" />
</ng-container>
<div class="modal-footer">
  <div
    class="flex justify-content-between"
    *ngIf="selection">
    <p-button
      (onClick)="close()"
      icon="pi pi-times"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
